<template>
  <content-container :overlay="loading" :container="true">

  </content-container>
</template>

<script>
import ContentContainer from "@/components/ContentContainer";

export default {
  name: "UserCheckoutResult",
  components: {
    ContentContainer,
  },
  props: ["action", "provider", "session_id", "licenseId"],
  data() {
    return {
      error: false,
      loading: false,
    };
  },
  mounted() {
    //console.log("CheckoutResult: action=" + this.action + ", provider=" + this.provider + ", session_id=" + this.session_id + ", licenseId=" + this.licenseId)
    if (this.action == "success") {
      this.$router.replace({
        name: "rdbmItem",
        params: { id: this.licenseId, action: this.action },
      })
    } else if (this.action == "canceled") {
      this.$router.replace({
        name: "rdbmItem",
        params: { id: this.licenseId, action: this.action },
      })
    } else {
      console.log("'Unknown action='" + this.action + "'");
      this.$router.replace({
        name: "rdbmItem",
        params: { id: this.licenseId, action: "error" },
      })
    }
  }
};
</script>

<style>

</style>